<template>
  <div>
    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Quality(beta)</el-breadcrumb-item>
          <el-breadcrumb-item>QC Report</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <!--<el-card>
      <el-row>
        <el-col :span="4"><div class="grid-content bg-purple"></div><img src="../../assets/spclogo.png" alt=""></el-col>
        <el-col :span="20"><h2 style="text-align: center;padding:0 20%" class="grid-content bg-purple">Sourcing Perfume & Cosmetic (SH) Ltd.
          Component Inspection Report</h2></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form style="margin-top: 50px" ref="form" :model="sizeForm" label-width="200px" size="mini">
            <el-form-item label="Supplier">
              <el-input v-model="sizeForm.name"></el-input>
            </el-form-item>
            <el-form-item label="Item Number">
              <el-input v-model="sizeForm.name"></el-input>
            </el-form-item>
            <el-form-item label="PO Number">
              <el-input v-model="sizeForm.name"></el-input>
            </el-form-item>
            <el-form-item label="Brand">
              <el-input v-model="sizeForm.name"></el-input>
            </el-form-item>
            <el-form-item label="Date of Inspection">
              <el-input v-model="sizeForm.name"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>-->
    <el-card>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="Inspection Date:">
          <el-input v-model="formInline.inspectionDate" placeholder="Inspection Date" clearable></el-input>
        </el-form-item>
        <el-form-item label="Item Number:">
          <el-input v-model="formInline.itemNumber" placeholder="Item Number" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="customerDialogOpen('add')">Add</el-button>
        </el-form-item>
      </el-form>

      <!-- CRProject 列表区域 -->
      <el-table :data="inspectionList" border stripe style="width: 100%">
        <el-table-column fixed type="index" label="#"></el-table-column>
        <el-table-column
          prop="inspectionDate"
          label="Inspection Date"         sortable
          width="190">
        </el-table-column>
        <el-table-column
          fixed
          prop="itemNumber"      sortable
          label="Item Number"
          width="190">
        </el-table-column>
        <el-table-column
          prop="description" sortable
          label="description"
          width="190">
        </el-table-column>
        <el-table-column
          prop="brand" sortable
          label="brand"
          width="190">
        </el-table-column>
        <el-table-column
          prop="supplier" sortable
          label="supplier"
          width="190">
        </el-table-column>
        <el-table-column
          prop="poNumber" sortable
          label="poNumber"
          width="190">
        </el-table-column>
        <el-table-column
          prop="actualQuantity" sortable
          label="actualQuantity"
          width="190">
        </el-table-column>
        <el-table-column
          prop="spcResult" sortable fixed="left"
          label="spcResult"
          width="110">
        </el-table-column>
        <el-table-column
          prop="inspector" sortable
          label="inspector"
          width="190">
        </el-table-column>
        <el-table-column
          prop="inspectionStatus" sortable
          label="inspectionStatus"
          width="190">
        </el-table-column>
        <el-table-column
          prop="finalDecision" sortable
          label="finalDecision"
          width="190">
        </el-table-column>
        <el-table-column
          prop="decisionBy" sortable
          label="decisionBy"
          width="190">
        </el-table-column>
        <el-table-column
          prop="comments" sortable
          label="comments"
          width="190">
        </el-table-column>
        <el-table-column
          prop="defect" sortable
          label="defect"
          width="190">
        </el-table-column>
        <el-table-column
          prop="sampleReceived" sortable
          label="sampleReceived"
          width="190">
        </el-table-column>
        <el-table-column
          prop="historyDefectSummary" sortable
          label="historyDefectSummary"
          width="190">
        </el-table-column>
        <el-table-column
          prop="year" sortable
          label="year"
          width="190">
        </el-table-column>
        <el-table-column
          prop="month" sortable
          label="month"
          width="190">
        </el-table-column>
        <el-table-column
          prop="week" sortable
          label="week"
          width="190">
        </el-table-column>
        <el-table-column
          prop="oneDrive" sortable
          label="oneDrive"
          width="190">
        </el-table-column>
        <el-table-column
          prop="mpsStatus" sortable
          label="mpsStatus"
          width="190">
        </el-table-column>
        <el-table-column
          prop="risk" sortable
          label="risk"
          width="190">
        </el-table-column>
        <el-table-column
          prop="spcNew" sortable
          label="spcNew"
          width="190">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="Create Time"
          width="190">
        </el-table-column>

        <el-table-column fixed="right" label="Operation" width="150">
          <template slot-scope="props">
            <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-card>

    <div id="printTest">
    <el-dialog title="" :visible.sync="dialogVisible"  width="70%">
     <!-- <el-form :inline="true" :model="ruleForm" class="demo-form-inline" label-width="175px" ref="editFormRef" :rules="editFormRules">

        <el-form-item label="Project Id" prop="selectedProjectId">
          <el-select v-model="ruleForm.selectedProjectId" placeholder="Please Choose" style="width: 200px" filterable remote
                     :remote-method="remoteMethod" :loading="loading">
            <el-option
              v-for="item in this.projectIdList"
              :key="item.project_id"
              :label="item.project_id"
              :value="item.project_id">
              <span style="float: left">{{ item.project_id }}</span>
              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.descr }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>-->
      <el-row>
        <el-col :span="4">
          <img style="width: 100%;" src="../../assets/spclogo.png" alt="">
        </el-col>
        <el-col :span="20" style="text-align: center;padding: 0 10%;"><h2 class="grid-content bg-purple">Sourcing Perfume & Cosmetic (SH) Ltd.
          Component Inspection Report</h2></el-col>
      </el-row>
      <br><br>
      <table class="table-body" cellspacing=0 cellpadding=0>
        <tbody>
        <tr>
          <td width="100%" colspan="8" class="section-header">Base Info</td>
        </tr>
        <tr>
          <td width="25%">Supplier:</td>
          <td width="25%" style="text-align: center">MATIN</td>
          <td width="25%">Item Number:</td>
          <td width="25%" style="text-align: center">16310-CP</td>
        </tr>
        <tr>
          <td width="25%">PO Number:</td>
          <td width="25%" style="text-align: center">RS16573</td>
          <td width="25%">Brand:</td>
          <td width="25%" style="text-align: center">A&F</td>
        </tr>
        <tr>
          <td width="25%">Date of Inspection:</td>
          <td width="25%" style="text-align: center">2021/6/22</td>
          <td width="25%">Inspection Status:</td>
          <td width="25%" style="text-align: center">re-inspection</td>
        </tr>
        <tr>
          <td width="25%">Type Of Product:</td>
          <td width="25%" style="text-align: center">Cap</td>
          <td width="25%">Order Quantity:</td>
          <td width="25%" style="text-align: center">80000</td>
        </tr>
        <tr>
          <td width="25%">Description Of Product:</td>
          <td colspan="3" width="25%" style="text-align: center">GU GUESS ICONIC EDP TRAVELSPRAY 15ML</td>
        </tr>
        <tr>
          <td width="25%">Actual Quantity:</td>
          <td width="25%" style="text-align: center">80000</td>
          <td width="25%">Balance Quantity:</td>
          <td width="25%" style="text-align: center"></td>
        </tr>
        <tr>
          <td width="25%">Sampling Quantity:</td>
          <td width="25%" style="text-align: center">200</td>
          <td width="25%">Sampling Cartons:</td>
          <td width="25%" style="text-align: center"></td>
        </tr>
        <tr>
          <td width="25%">Sampling Level for appearance:</td>
          <td width="25%" style="text-align: center">I</td>
          <td colspan="2"></td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td width="25%">Final result:</td>
          <td width="25%" style="text-align: center;color:#409EFF;">Conditional Accept</td>
          <td width="25%" colspan="2"></td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td width="25%">Packaging Control:</td>
          <td colspan="3" style="text-align: center">
            <el-checkbox v-model="checked">Pallet</el-checkbox>
            <el-checkbox v-model="checked">Carton</el-checkbox>
            <el-checkbox v-model="checked">Shipping mark</el-checkbox>
          </td>
        </tr>
        <tr>
          <td width="25%">Control elements checking:</td>
          <td colspan="3" style="text-align: center">
            <el-checkbox v-model="checked">Drawing</el-checkbox>
            <el-checkbox v-model="checked">Approved Sample</el-checkbox>
            <el-checkbox v-model="checked">Artwork</el-checkbox>
            <el-checkbox v-model="checked">Defect Range Board</el-checkbox>
            <el-checkbox v-model="checked">Specification</el-checkbox>
            <el-checkbox v-model="checked">Color Range Board</el-checkbox>
          </td>
        </tr>
        <tr>
          <td width="25%">Artwork inspection:</td>
          <td colspan="3" style="text-align: center">
            <el-checkbox v-model="checked">OK</el-checkbox>
            <el-checkbox v-model="checked">NG</el-checkbox>
            <el-checkbox v-model="checked">NA</el-checkbox>
          </td>
        </tr>
        <tr>
          <td width="25%">Color inspection:</td>
          <td colspan="3" style="text-align: center">
            <el-checkbox v-model="checked">Lighter</el-checkbox>
            <el-checkbox v-model="checked">OK</el-checkbox>
            <el-checkbox v-model="checked">Darker</el-checkbox>
            <el-checkbox v-model="checked">NA</el-checkbox>
          </td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td width="25%">Remark:</td>
          <td colspan="3" width="25%" style="text-align: center"></td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td colspan="4" class="section-header">Appearance Inspection Level I / Level II (ISO 2859 )</td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center">Discription Of Defect</td>
          <td colspan="2" style="text-align: center">Quantity</td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center"></td>
          <td colspan="2" style="text-align: center">
            <div style="display: flex;text-align: center">
              <div style="flex: 1;">Cr 0.65</div>
              <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">Maj 1.5</div>
              <div style="flex: 1;">Mir 4.0</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center"></td>
          <td colspan="2" style="text-align: center">
            <div style="display: flex;text-align: center">
              <div style="flex: 1;">1</div>
              <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">2</div>
              <div style="flex: 1;">3</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center"></td>
          <td colspan="2" style="text-align: center">
            <div style="display: flex;text-align: center">
              <div style="flex: 1;">1</div>
              <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">2</div>
              <div style="flex: 1;">3</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center"></td>
          <td colspan="2" style="text-align: center">
            <div style="display: flex;text-align: center">
              <div style="flex: 1;">1</div>
              <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">2</div>
              <div style="flex: 1;">3</div>
            </div>
          </td>
        </tr>
<!--        <tr>-->
<!--          <td colspan="4">:</td>-->
<!--        </tr>-->
        <tr>
          <td colspan="2" style="text-align: center">Total</td>
          <td colspan="2" style="text-align: center">
            <div style="display: flex;text-align: center">
              <div style="flex: 1;">3</div>
              <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">6</div>
              <div style="flex: 1;">9</div>
            </div>
          </td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td colspan="4" class="section-header">Dimensional measurement,Functional and decoration resistance test  S-2     AQL =1.5  (ISO 2859 )     </td>
        </tr>
        <tr>
          <td width="25%">Item Of Dimensional/Functional</td>
          <td colspan="3"></td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">LCL</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">STD</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">UCL</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">1</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">2</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">Min</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">Max</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">Avg</td>
          <td width="25%" style="text-align: center">1.00</td>
          <td width="25%" style="text-align: center">0.50</td>
          <td width="25%" style="text-align: center">2.50</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">CPK</td>
          <td width="25%" style="text-align: center">0.22</td>
          <td width="25%" style="text-align: center">0.14</td>
          <td width="25%" style="text-align: center">-0.08</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">Result</td>
          <td width="25%" style="text-align: center">OK</td>
          <td width="25%" style="text-align: center">NG</td>
          <td width="25%" style="text-align: center">NG</td>
        </tr>
        <tr>
          <td width="25%" style="text-align: center">Conclusion</td>
          <td width="25%" style="text-align: center">OK</td>
          <td width="25%" style="text-align: center">NG</td>
          <td width="25%" style="text-align: center">NG</td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td width="25%">Remark:</td>
          <td colspan="3" width="25%" style="text-align: center"></td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td width="25%">Inspected By:</td>
          <td width="25%" style="text-align: center"></td>
          <td colspan="2" width="25%" style="text-align: center"></td>
        </tr>
        <tr>
          <td width="25%">Approved By:</td>
          <td width="25%" style="text-align: center"></td>
          <td colspan="2" width="25%" style="text-align: center"></td>
        </tr>
        <tr><td colspan="4" style="height: 5px"> </td></tr>
        <tr>
          <td colspan="4">
            <div style="display: flex;text-align: center;">
            <div style="flex: 1;padding: 2rem">
              <el-image
                style="width: 100%;"
                :src="url"
                :preview-src-list="srcList"
                ></el-image>
            </div>
            <div style="flex: 1;padding: 2rem">
              <el-image
                style="width: 100%;"
                :src="url"
                :preview-src-list="srcList"
              ></el-image>
            </div>
            <div style="flex: 1;padding: 2rem">
              <el-image
                style="width: 100%;"
                :src="url"
                :preview-src-list="srcList"
              ></el-image>
            </div>
              <div style="flex: 1;padding: 2rem">
                <el-image
                  style="width: 100%;"
                  :src="url"
                  :preview-src-list="srcList"
                ></el-image>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
        <div style="page-break-after:always"></div>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
<!--        <el-button type="primary" @click="timelineOpen">Ok</el-button>-->
        <el-button v-if="this.operation==='view'" type="primary" v-print="'#printTest'">Print</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      srcList: [
        'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fcbu01.alicdn.com%2Fimg%2Fibank%2FO1CN01X69KYr1cumkbfbTNt_%21%212213215773661-0-cib.jpg&refer=http%3A%2F%2Fcbu01.alicdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1695886446&t=914814f517393710cac9b87017ae32f1'
      ],
      url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fcbu01.alicdn.com%2Fimg%2Fibank%2FO1CN01X69KYr1cumkbfbTNt_%21%212213215773661-0-cib.jpg&refer=http%3A%2F%2Fcbu01.alicdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1695886446&t=914814f517393710cac9b87017ae32f1',
      operation: '',
      dialogVisible: false,
      inspectionList: [],
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formInline: {
        itemNumber: '',
        inspectionDate: '',
        page: 1,
        rows: 100
      }
    }
  },
  name: 'RawMaterial',
  created () {
    this.getInspectionList()
  },
  methods: {
    async view (value) {
      this.dialogVisible = true
      this.operation = 'view'
    },
    async getInspectionList () {
      const { data: res } = await this.$http.get('/QCReport/getInspectionList', { params: this.formInline })
      this.inspectionList = res
    },
    onSubmit () {
      console.log('submit!')
    },
    customerDialogOpen () {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }
  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }
</style>
